import styled from "styled-components";

export const Styled = styled.div`
    /* border: 1px solid #f00; */
    margin-top: 30px;

    .wrapper {
    }
`;

export const Header = styled.div`
    /* border: 1px solid #f00; */

    .row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .heading_text {
            letter-spacing: -0.025em;
            line-height: 1;
            font-weight: 600;
            font-size: 1.5rem;
            line-height: 2rem;
            color: var(--primary-text-color);
        }

        .add_video {
            background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
            color: #fff;

            &:hover {
                background-color: hsl(265 89% 60% / 0.9);
            }
        }
    }

    .row2 {
        color: var(--secondary-text-color);
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
`;

export const CTAButton = styled.button`
    border: none;
    display: flex;

    --tw-ring-offset-color: hsl(var(--background));
    --tw-text-opacity: 1;
    color: hsl(0 0% 100% / var(--tw-text-opacity, 1));
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    --tw-bg-opacity: 1;
    background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
    border-radius: calc(var(--radius) - 2px);
    border-radius: 6px;
    white-space: nowrap;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    height: 2.25rem;
    display: inline-flex;
    cursor: pointer;

    &:hover {
        background-color: hsl(265 89% 60% / 0.9);
    }
`;
